module.exports = __webpack_public_path__ + "img/9788960174160.7621f4bc.jpg";